export default "__VITE_ASSET__8f2e28f9__"